import React, { useEffect } from "react";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";
import SidebarNavAccordion from "../../../SidebarNavAccordion";
import { useDispatch, useSelector } from "react-redux";
import { startUIShowModulesCount } from "../../../../redux/actions/administrador/ui/ui";

export const Modules_Administratives = () => {
    const dispatch = useDispatch();
    const { hasPermission } = useHasPermission();
    const { color_text_menu_accordion } = useSelector((state) => state.config);

    const canShowAccordion = hasPermission([
        "INCIDENTS_CAPTURE",
        "CAN_REGISTER_NEWS",
        "EVENTS",
        "EVENTS_ADMIN",
        "SHOW_MANUALS",
        "TICKETS_USERS",
        "AREA_DIRECTOR",
        "FORMATS_PUBLIC",
        "IT_TICKETS",
        "MAINTENANCE_TICKETS",
        "DISTRIBUTION_LISTS",
        "CUSTOMERS",
        "OPPORTUNITIES",
        "PORTFOLIOS",
    ]);

    useEffect(() => {
        if (canShowAccordion) {
            dispatch(startUIShowModulesCount("Modules_Administratives"));
        }
    }, [canShowAccordion]);

    return (
        <div>
            {canShowAccordion && (
                <SidebarNavAccordion
                    title={"Administrativos"}
                    itemLevel={0}
                    color={color_text_menu_accordion}
                    iconLeftClassName="fa-solid fa-briefcase fa-xl"
                >
                    {hasPermission("CAN_REGISTER_NEWS") && (
                        <div>
                            <NavLinkApp
                                name="Avisos"
                                to="/app/news"
                                icon={
                                    <IconApp iconClassName="fas fa-bullhorn c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </div>
                    )}
                    {hasPermission("OPPORTUNITIES") && (
                        <NavLinkApp
                            name="Asuntos"
                            to="/app/opportunities"
                            icon={
                                <IconApp iconClassName="fas fa-hand-holding-dollar c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("INCIDENTS_CAPTURE") && (
                        <NavLinkApp
                            name="Capturar Incidencia"
                            to="/app/calendar/"
                            icon={
                                <IconApp iconClassName="fas fa-calendar-times c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("CUSTOMERS") && (
                        <SidebarNavAccordion
                            title={"Clientes"}
                            itemLevel={1}
                            iconLeftClassName="fa-solid fa-user-tie"
                        >
                            <NavLinkApp
                                name="Personas físicas"
                                to="/app/customers/fisicas"
                                icon={
                                    <IconApp iconClassName="fas fa-user c-sidebar-nav-icon"></IconApp>
                                }
                            />
                            <NavLinkApp
                                name="Personas morales"
                                to="/app/customers/morales"
                                icon={
                                    <IconApp iconClassName="fas fa-building c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </SidebarNavAccordion>
                    )}
                    {hasPermission(["EVENTS", "EVENTS_ADMIN"]) && (
                        <NavLinkApp
                            name="Reservar espacios"
                            to="/app/eventos/"
                            icon={
                                <IconApp iconClassName="fas fa-calendar-alt c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission("ENTERPRISES_APP") && (
                        <NavLinkApp
                            name="Empresas"
                            to="/app/enterprises"
                            icon={
                                <IconApp iconClassName="fas fa-buildings c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission("DISTRIBUTION_LISTS") && (
                        <div>
                            <NavLinkApp
                                name="Listas de distribución"
                                to="/app/distribution_lists"
                                icon={
                                    <IconApp iconClassName="fas fa-users-between-lines c-sidebar-nav-icon"></IconApp>
                                }
                            />
                        </div>
                    )}

                    {hasPermission("SHOW_MANUALS") && (
                        <NavLinkApp
                            name="Manuales"
                            to="/app/manuals/public"
                            icon={
                                <IconApp iconClassName="fas fa-book c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission(["IT_TICKETS", "MAINTENANCE_TICKETS"]) && (
                        <NavLinkApp
                            name="Gestion tickets"
                            to="/app/soporte/tickets"
                            icon={
                                <IconApp iconClassName="fas fa-tools c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("TICKETS_USERS") && (
                        <NavLinkApp
                            name="Ver/Solicitar Tickets"
                            to="/app/soporte"
                            icon={
                                <IconApp iconClassName="fas fa-book c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("FORMATS_PUBLIC") && (
                        <NavLinkApp
                            name="Banco de documentos"
                            to="/app/formats/public"
                            icon={
                                <IconApp iconClassName="fas fa-file-alt c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                    {hasPermission("AREA_DIRECTOR") && (
                        <NavLinkApp
                            name="Director de área"
                            to="/app/area_director/list"
                            icon={
                                <IconApp iconClassName="fas fa-praying-hands c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}

                    {hasPermission("PORTFOLIOS") && (
                        <NavLinkApp
                            name="Portafolios"
                            to="/app/portfolios"
                            icon={
                                <IconApp iconClassName="fas fa-briefcase c-sidebar-nav-icon"></IconApp>
                            }
                        />
                    )}
                </SidebarNavAccordion>
            )}
        </div>
    );
};
